module.exports = __webpack_public_path__ + "img/ice_cold_shot_green_start.d1c50530.png";